/* Use to check if for example a switch statement is, or
 * bunch of if statements are, exhaustive. */
export function assertNever(_x) {
    throw new Error('Did not expect to get here');
}
//# sourceMappingURL=ts-assert-never.js.map